module.exports = __webpack_public_path__ + "media/images/royalslider/d-5490e83051e2fe8cb871e390b50e4eb5.jpg";